import React, { useState, useEffect } from 'react';
import { Pie } from '@ant-design/plots';

const PieChart = ({data,color,type}) => { 
 
  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    if (color === "csGender") {
      setChartColor(["#2193AE", "#724DAD", "#4945A8", "#724DAD",'#487386', '#2b8a84', '#8db05c']);
    } 
    else if(color === "stemiGenderPie"){
      setChartColor(["#9d405f","#487386", "#8db05c", "#f9c232", "#f36523", "#9d405f", "#487386", "#2b8a84", "#8db05c"]);
    }
    else if (color === "stemiSectorPie") {
      setChartColor(["#3f81af", "#37948e", "#95ba60", "#f9c232", "#f36523","#9d405f", "#487386", "#2b8a84", "#8db05c",]);
    }
    else {
      // setChartColor(['#3f81af', '#37948e', '#95ba60', '#f9c232', '#f36523', '#9d405f', '#487386', '#2b8a84', '#8db05c']);
      setChartColor(["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"]);
    }
  };
 
  const config = {
    data,
    angleField: 'value',
    colorField: 'type',
    scale: {
      color: {
        range: chartColor
      },
    },
    innerRadius: 0,
    label: {
      text: ({ percent }) => {

        return `${percent > 0 ? percent.toFixed(2):0}%`;
      },
      style: {
        fontWeight: 'bold',
      },
    },
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
    tooltip: {
      items: [
        {
          channel: "color",
          name:type,
        },
        {
          channel: "y0",
          name:'Number:',
          valueFormatter: (val) => `${val}`,
        },
       ],
     },
  }; 
  return ( <> <Pie {...config} /> </> )
};



export default PieChart;